import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import CustomNavbar from "./CustomNavbar";
import Sidebar from "./Sidebar";
import SystemOperationsBar from "./SystemOperations/SystemOperationsBar";
import { getInternalBranding } from "./Dashboards/dashboardService";
import "./ShellLayout.css";

function PrivateLayout() {
  const location = useLocation();
  const isMobileViewport = () => window.innerWidth <= 720;
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    () => !isMobileViewport()
  );


  useEffect(() => {
    const handleResize = () => {
      if (isMobileViewport()) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobileViewport()) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    let active = true;

    const applyBranding = async () => {
      try {
        const brand = await getInternalBranding();
        if (!active) return;

        const root = document.documentElement;
        root.style.setProperty(
          "--client-primary",
          brand?.primary_color || "#660030"
        );
        root.style.setProperty(
          "--client-secondary",
          brand?.secondary_color || "#003366"
        );
        root.style.setProperty(
          "--client-accent",
          brand?.accent_color || "#8a1748"
        );
      } catch {
        // Keep the CSS fallbacks if branding cannot be loaded.
      }
    };

    applyBranding();
    window.addEventListener(
      "netri-branding-updated",
      applyBranding
    );

    return () => {
      active = false;
      window.removeEventListener(
        "netri-branding-updated",
        applyBranding
      );
    };
  }, []);

  return (
    <div className="netri-shell">
      <Sidebar
        isOpen={isSidebarOpen}
        onNavigate={() => {
          if (isMobileViewport()) setIsSidebarOpen(false);
        }}
      />

      {isSidebarOpen && (
        <button
          type="button"
          className="netri-sidebar-backdrop"
          aria-label="Close navigation"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="netri-shell-main">
        <CustomNavbar
          onToggleSidebar={() =>
            setIsSidebarOpen((current) => !current)
          }
        />

        <main className="netri-shell-content">
          <Outlet />
        </main>
        <SystemOperationsBar />
      </div>
    </div>
  );
}

export default PrivateLayout;
